import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { RestoreComponent } from './restore/restore.component';
import { ChangeComponent } from './change/change.component';
import { EmailComponent } from './email/email.component'
import { PagesModule } from '../pages/pages.module';
import { Ng9RutModule } from 'ng9-rut';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { SharedModule } from '../shared/shared.module';
import { PreRegisterComponent } from './preregister/preregister.component';
import { TerminosYCondicionesModalComponent } from './register/terminos-ycondiciones-modal/terminos-ycondiciones-modal.component';
import { VerificarClavesComponent } from './register/verificar-claves/verificar-claves.component';

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    RestoreComponent,
    ChangeComponent,
    EmailComponent,
    PreRegisterComponent,
    TerminosYCondicionesModalComponent,
    VerificarClavesComponent,
  ], exports:
    [
      LoginComponent,
      RegisterComponent,
      PreRegisterComponent
    ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PagesModule,
    Ng9RutModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    SharedModule,
  ],
  providers: [],
})
export class AuthModule { }
